define('TescoMobile_Customer/js/view/account/switcher-loader',['jquery', 'domReady!'], function ($) {
  'use strict';

  return function () {
    $("#customer-subscriptions").change(function () {
      $('#customer-account-switcher').trigger('submit');
    });
    if ($('#customer-subscriptions option').length === 1) {
      $('#customer-subscriptions').addClass('single');
      $('#customer-subscriptions').attr('disabled', 'disabled');
    }
  };
});

